import {
  productFamilyImageIdFormat,
  productImageIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const submitImageFeedback = {
  name: "submitImageFeedback" as const,
  input: z.object({
    imageId: z.union([
      productFamilyImageIdFormat.schema,
      productImageIdFormat.schema,
    ]),
    feedback: z.enum(["positive", "negative"]).nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
